/* ===========================================================================
   Nintara — Diaper Bag Customer Reviews
   File: assets/diaper-bag-reviews.js   (loaded with `defer`)

   Rewritten rather than reused from testimonial-cstm-js.js, which could not
   work here:
     - It hardcodes `.testimonial-wrapper-199126` and querySelector (singular),
       so with the section rendered twice only the first instance would bind.
     - visibleCount() hardcodes breakpoints in JS that must stay in sync with
       breakpoints in CSS. Here the count is read from the CSS custom property,
       so there is one source of truth.
     - It reads offsetWidth on load. This section renders twice with one copy
       display:none, where every measurement is 0 — so measuring is deferred
       until the instance is actually visible (see the bagchange hook).

   Generic over every [data-nbr] root.
   =========================================================================== */

(function () {
  'use strict';

  if (window.__nintaraReviewsLoaded) return;
  window.__nintaraReviewsLoaded = true;

  var instances = [];

  function initRoot(root) {
    if (!root || root.__nbrInit) return;
    root.__nbrInit = true;

    var track = root.querySelector('[data-nbr-track]');
    var prev  = root.querySelector('[data-nbr-prev]');
    var next  = root.querySelector('[data-nbr-next]');
    var dots  = root.querySelector('[data-nbr-dots]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nbr-card]'));
    if (!track || !cards.length) return;

    /* Per-view comes from CSS, not from duplicated JS breakpoints. */
    function perView() {
      var v = parseFloat(getComputedStyle(root).getPropertyValue('--nbr-per'));
      return isNaN(v) || v < 1 ? 1 : Math.round(v);
    }

    function step() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function maxIndex() {
      return Math.max(0, cards.length - perView());
    }

    function currentIndex() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }

    function buildDots() {
      if (!dots) return;
      var count = maxIndex() + 1;
      /* One page means nothing to page through. */
      if (count < 2) { dots.innerHTML = ''; dots.hidden = true; return; }
      dots.hidden = false;

      if (dots.children.length === count) return;   /* nothing changed */
      dots.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nbr__dot';
        b.setAttribute('aria-label', 'Go to review ' + (i + 1));
        b.setAttribute('data-nbr-dot', String(i));
        dots.appendChild(b);
      }
    }

    function paint() {
      var i = currentIndex();
      var max = maxIndex();

      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= max;

      var overflows = track.scrollWidth - track.clientWidth > 1;
      root.classList.toggle('has-overflow', overflows);

      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, n) {
          var on = n === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
    }

    function scrollToIndex(i) {
      var max = maxIndex();
      i = Math.max(0, Math.min(i, max));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });

    if (dots) {
      dots.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        var d = e.target.closest('[data-nbr-dot]');
        if (d) scrollToIndex(parseInt(d.getAttribute('data-nbr-dot'), 10) || 0);
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    function refresh() {
      /* Zero width means this instance is still display:none — every
         measurement would be wrong, so do nothing until it is shown. */
      if (!track.clientWidth) return;
      buildDots();
      paint();
    }

    refresh();
    instances.push({ root: root, refresh: refresh });
  }

  function refreshAll() {
    instances = instances.filter(function (i) { return document.contains(i.root); });
    instances.forEach(function (i) { i.refresh(); });
  }

  window.addEventListener('resize', refreshAll, { passive: true });

  /* This instance may have just become the visible one. */
  document.addEventListener('nintara:bagchange', function () {
    window.requestAnimationFrame(refreshAll);
  });

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-nbr]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function () {
    initAll();
    window.requestAnimationFrame(refreshAll);
  });
})();
